import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';
import DeviceConfig from '@devices/config';
import withImage from '../../../../shared/components/utils/hoc/withImage';

const DetailEventPhoto = styled.img<React.CSSProperties>`
  position: absolute;
  left: ${Screen.widthRatio * 420}px;
  height: ${Screen.widthRatio * 845}px;
  width: ${Screen.widthRatio * 1500}px;
  z-index: -1;
  object-fit: ${() =>
    DeviceConfig.capabilities.image.disableFitCover ? 'unset' : 'cover'};
`;

export default withImage(DetailEventPhoto);
